<template>
  <div class="honor-container">
    <common-header>
      <img slot="content" class="bg-img" :src="bannerImg | imgFilter" />
      <banner-content
        slot="content"
        title="荣誉资质"
        en-title="HONOR QUALIFICATIONS"
        content="久凌创新成立以来累计获得多项荣誉与认证，<br/> 在发展过程中注重自主知识产权的保护，多项产品通过了检测认证 "
      />
    </common-header>
    <vue-lazy-component>
      <pageItemContainer>
        <common-title
          title="HONOR"
          subTitle="QUALIFICATION"
          contentTitle="荣誉资质"
        />
        <ent-history />
      </pageItemContainer>
      <skeleton slot="skeleton"></skeleton>
    </vue-lazy-component>
    <vue-lazy-component @init="init">
      <ent-info :entInfoData="entInfoData" />
      <skeleton slot="skeleton"></skeleton>
    </vue-lazy-component>

    <vue-lazy-component>
      <pageItemContainer>
        <entcertificate :honorData="honorData" />
      </pageItemContainer>
      <skeleton slot="skeleton"></skeleton>
    </vue-lazy-component>
  </div>
</template>
<script>
import commonHeader from "@/components/commonHeader.vue";
import bannerContent from "@/components/bannerContent.vue";
import commonTitle from "@/components/commonTitle.vue";
import entInfo from "./components/entInfo.vue";
import pageItemContainer from "@/components/pageItemContainer.vue";
import entHistory from "./components/entHistory.vue";
import entcertificate from "./components/entcertificate.vue";
import { getAllHonor, getContactus } from "@/api/index.js";
import { mapActions, mapGetters } from "vuex";
import skeleton from "@/components/skeleton";

export default {
  components: {
    commonHeader,
    commonTitle,
    bannerContent,
    entInfo,
    pageItemContainer,
    entHistory,
    entcertificate,
    skeleton,
  },
  data() {
    return {
      entInfoData: {
        year: 0,
        honor: 0,
        service: 0,
        evaluate: 0,
      },
      honorData: [],
    };
  },
  mounted() {
    this.initCertificateInfo();
    if (!this.banner(4).length) this.getBanner(4);
  },
  methods: {
    init() {
      this.initentInfoData();
    },
    async initentInfoData() {
      const res = await getContactus().catch((e) => false);
      if (!res || res.code != 200) return;
      const { establish_time, aptitude_num, project_num } = res.data;
      this.entInfoData = {
        year: establish_time,
        honor: aptitude_num,
        service: project_num,
        evaluate: 100,
      };
    },
    async initCertificateInfo() {
      const res = await getAllHonor().catch((e) => false);
      if (!res || res.code != 200) return;
      this.honorData = res.data;
    },
    ...mapActions("banner", ["getBanner"]),
  },
  computed: {
    ...mapGetters("banner", ["banner"]),
    bannerImg() {
      let arr = this.banner(4);
      return arr.length ? arr[0].carousel_image : "";
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("~@/assets/css/common.scss");
.honor-container {
  width: 100%;
  background-color: #fff;
  .bg-img {
    width: 100%;
  }
  ::v-deep .sub-title {
    margin-bottom: 10px;
  }
}
</style>
